/**
 * useIsMobile — UA 检测 + 视口宽度判定(F2-12 移动端 H5 自适应)
 *
 * 双保险:
 * 1. UA:Android/iPhone/iPad/iPod 等 → true
 * 2. 视口:< 768px → true(小屏 PC 浏览器也算)
 *
 * resize 监听:桌面浏览器缩窗到 < 768 也触发
 */
import { useState, useEffect } from 'react'

const MOBILE_BREAKPOINT = 768

function detectMobile() {
  if (typeof window === 'undefined') return false
  const ua = (navigator.userAgent || '').toLowerCase()
  const mobileUA = /android|webos|iphone|ipad|ipod|blackberry|windows phone|iemobile|opera mini|mobile safari/.test(ua)
  const smallViewport = window.innerWidth < MOBILE_BREAKPOINT
  return mobileUA || smallViewport
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(detectMobile)

  useEffect(() => {
    const handler = () => setIsMobile(detectMobile())
    window.addEventListener('resize', handler)
    return () => window.removeEventListener('resize', handler)
  }, [])

  return isMobile
}